import { EProduct } from "../app/component/searched/models/searched.model";
export const typeApp = {
    NCB: 40,
    LIFEMILES: 38,
    SCOTIA: 41,
    MR: 52,
    CICB: 31,
    LIFEMILES_TRAVEL: 60,
    FC: 33,
    APAP: 62,
    CRYPTMI: 75
};
export const environment = {
    production: false,
    version: "S v2.4.0(07)",
    consolidurl: "/consolid/",
    middlewareurl: "/api/",
    middlewareBenefitsURL: "/apib/",
    activitiesurl: "/juniperapi/",
    uriPromociones: "assets/data/promociones.json",
    uriSlider: "assets/data/slider.json",
    pipeMilesFormat: "0.0-2",
    pipeCurrencyFormat: "1.2-2",
    subdomainBrands: {
        "scotia.": "scotia",
        "scotia-rewards.": "scotia",
        "nft.scotia-rewards.": "scotia",
        "localhost": "scotia"
    },
    brands: {
        scotia: {
            novaeUniversalUrlBase: "https://apiproxy-uat.scotia-rewards.com/universal/",
            CONFIG_USER_GET_JWTTOKEN_URL: "https://apiproxy-uat.scotia-rewards.com/universal/v1/getCountryV3",
            UNIVERSAL_GET_JWTTOKEN_URL: "aHR0cHM6Ly9hcGlwcm94eS11YXQuc2NvdGlhLXJld2FyZHMuY29tL3VuaXZlcnNhbC92MS9nZXRKV1RUb2tlbg==",
            /*
            uJU: "Zjg3NDUwY2RmMGVmNDEyYjliMmJhOGI4YmNlMjU5ZTQyNzJiNThjMzYzODM4MTZlZTg5ZTZhODM1Zjg4MDNkZWZhYTllN2YyZTU0NzQzNjM4ZWQ1MWQ1NTVmMjU2MDZiPT09ZmYyMjBlM2QxN2JmNzEyMDg4MzIzMTNhMmYyYWFjNzE1YzBlNGNlZjEzODY1NDVjMjE4MWFkOTk3ZjMwNjM3NQ==",
            uJP: "ZjdkYzY0YWIwODRjZmNjZTE4NzM3YjA4YjljN2NhYTFjZjg2MDdkYzhhYmZiYjRlM2U0YmM5N2IzMzk3MTRhMGM4MjRmOTRiMWE4ODQxODU5MjMwMDljMThlM2ExNDlmPT09ZjNkM2ZlOGNlNjY5MDM0MWQwZTNlOWJmNWY3OWJkZDM2YWQ1ODUxYjhiZmVkOTA5ZTgwNjk5NWEzOTJiZWM4OGRhYmZkZmZiZjcwYzNjYjVkZGI5Y2M1YzVkNmNhNGQz",
            sK: "OWE5OTM3ZWEwODY2ZmM4YjE2ZmJlZDUzNDFkNmQ4NWRlNWQ0ZmE2YjgwMDgxYmEyODI3YjZkYTkyMWQzMWRlNjBjOTIwOWQxNWJjOTQ3NjY4MGQ4YmJiZWYyNTkyNmZjPT09MDUzZGYwYzU2YzIxOTQyZmMxOTFiYzI0MzhmZWY1MWIyMGZiYTg4MzAwZGJmMGQ0MTc1YTA4Y2NlOGI4ODI1NzI2NGJmNTY4NDU0ZGVkMzI1OGZhMWUwNjA5Njc4N2Rj",
            proxyConfig: {
                tC: "Nzc0NjIyOGVkNDJhZTVkZDI4ZjczMjhkMjBiYzZhYjJlOTMyZjc0MzZlMWMxMmI0ZmM5NzlmZmNkOTJkNzJhZWFlZGVlNGNmYmVkZDQ0NzE5YTc1MDQzNzFhZmE2YzdmPT09NGNkYzc3ZWE1MWYzZGNlNDhmNzliNjY0ZDU5YWIzMDcxN2EzYzY0ZjAzMTQxYzE2ZDczNTYwZDM4Y2IwZjcyZWI5NzhmNGVkNTVhMGUwNDZmN2UyMmZhZDUxZGI3Zjdm"
            },
            //*/
            timeZoneDefault: "QW1lcmljYS9Cb2dvdGE=",
            languajeTimeDefault: "ZW4tVVM=",
            favicon_route: "assets/favicon_alle/favicon.ico",
            channelId: 2,
            registrationType: 4,
            ccBin: "411111",
            defaultLanguaje: "en",
            targetCurrency: "USD",
            applicationId: "41",
            appName: "Scotia Rewards",
            urlSearchIframe: "http://localhost:8080/test-iframe-op/testIframeJuniper.html",
            lpBrandName: "SC",
            subBrand: true,
            speciali18n: true,
            useJwtToken: true,
            merchantAccountId: {
                benefits: 1,
                hotel: 2,
                flight: 3,
                activities: 4,
                travel: 5,
                cars: 6,
                transfers: 7,
                miles: 8,
                donate: 9
            },
            terminos_y_condiciones: {
                ES: "https://wearenovae.com/miles/terms-and-conditions/en/index.html?programa=2&header=oculto",
                EN: "https://wearenovae.com/miles/terms-and-conditions/en/index.html?programa=2&header=oculto"
            },
            config: {
                hasBenefits: false,
                hasActivities: true,
                hasHeaderDownload: true,
                hasTwoLanguages: true,
                isNewHome: true,
                isNewMenu: true,
                isLangNavigator: false,
                showButtonWhatsApp: false,
                hasFirebase: true
            },
            optionmenu: [
                { label: "NAV.home", router: "/home", tabSelect: [EProduct.HOME] },
                { label: "NAV.travel", router: "/travel", tabSelect: [EProduct.TRAVEL] }
            ],
            //aca: "G2ieNaNoTnVaIaIue1S",
            videosLandingEN: {
                sectionOne: {
                    one: { url: "https://player.vimeo.com/external/462698340.hd.mp4?s=4831102565ac2c2212934a453d5bd09530ff23c1&profile_id=175" },
                    two: { url: "https://player.vimeo.com/external/462698416.hd.mp4?s=ab891ae01fe13eb9e1f4927f6de49f984d5919e3&profile_id=175" },
                    three: { url: "https://player.vimeo.com/external/463606914.hd.mp4?s=db825b2b33e4796871325a2db3e92aed1fbb3e73&profile_id=175" }
                },
                sectionTwo: {
                    one: { url: "https://player.vimeo.com/external/462698781.hd.mp4?s=283cf3067ee649009c65da11de1b126a07235e7c&profile_id=175" },
                    two: { url: "https://player.vimeo.com/external/463304224.hd.mp4?s=9a735e7da10d17023936406d713cbfb2e1a859cf&profile_id=175" },
                    three: { url: "https://player.vimeo.com/external/463577289.hd.mp4?s=578a08311c6f5b60c33ccd510b4cff1d3891177c&profile_id=175" }
                },
                sectionThree: {
                    one: { url: "https://player.vimeo.com/external/463577355.hd.mp4?s=5215a6a8d4ea54b6459994b227692dbf9a3f8ff2&profile_id=175" },
                    two: { url: "https://player.vimeo.com/external/464391578.hd.mp4?s=3504d011d22aca77668707c703531892ec9f7eed&profile_id=175" },
                    three: { url: "https://player.vimeo.com/external/463194609.hd.mp4?s=412f1a5f980043f446a3fab5e3080f3e05c408fe&profile_id=175" }
                }
            },
            videosLandingES: {
                sectionOne: {
                    one: { url: "https://player.vimeo.com/external/463492992.hd.mp4?s=3ca8d80eed54324cbc192c8b42a02edcc28675bc&profile_id=175" },
                    two: { url: "https://player.vimeo.com/external/463493089.hd.mp4?s=07143435615817a02aab44f2a1099ce4c43705cc&profile_id=175" },
                    three: { url: "https://player.vimeo.com/external/463606881.hd.mp4?s=2873823cf83208952b4f8f969a9040347394540d&profile_id=175" }
                },
                sectionTwo: {
                    one: { url: "https://player.vimeo.com/external/470228705.hd.mp4?s=d198b0fe09e65353b545204717884ce24d29e04c&profile_id=175" },
                    two: { url: "https://player.vimeo.com/external/463493247.hd.mp4?s=d00a20fde5488d6ad75b9250c13770c9e14b2bd7&profile_id=175" },
                    three: { url: "https://player.vimeo.com/external/463577277.hd.mp4?s=4b9301389acd3d8f05c0ab8776037d97934e5e95&profile_id=175" }
                },
                sectionThree: {
                    one: { url: "https://player.vimeo.com/external/463577357.hd.mp4?s=c9e05c260010388bec99e471f448f721e855ccd2&profile_id=175" },
                    two: { url: "https://player.vimeo.com/external/464391355.hd.mp4?s=149c858c0b5a27225b08922f2d0e6bf35e40049f&profile_id=175" },
                    three: { url: "https://player.vimeo.com/external/463492555.hd.mp4?s=23cb6c9a95eb46cbcd0dc165d42d77f0785a6ffd&profile_id=175" }
                }
            },
            firebaseConfig : {
                apiKey: "AIzaSyBF9OyR-abmfVh1XU7zym2Zh5oOs_DPiDE",
                authDomain: "scotia-rewards.firebaseapp.com",
                projectId: "scotia-rewards",
                storageBucket: "scotia-rewards.firebasestorage.app",
                messagingSenderId: "696437569376",
                appId: "1:696437569376:web:b7250ec36b5ba233b01005",
                measurementId: "G-89TLY3LRD3"
            }
        }
    },
    google_analytics_gtag: "G-FW8C2PNG8P",
    dataContactObj: {
        name: "Bibiana",
        lastname: "Montoya",
        email: "contacto@allegrarewards.com",
        phone: "(+57) 3214344842",
        country: "Colombia",
        city: "Bogot\u00E1"
    }
};